// ═══════════════════════════════════════════════════════════════════════════════
//  src/components/onboarding/OptionCards.jsx
//  MICROSERVICIO ONBOARDING v3 — Componente base de tarjetas
//
//  Lo consumen las Pantallas 1, 2 (×2 preguntas), 3, 4 (×2) y 6.
//
//  [v2.1] Soporta opciones de TEXTO LIBRE ("Otro objetivo distinto..."):
//  al seleccionarlas revela un <input> neumórfico con maxLength, tal como
//  especifica la mecánica UI del documento maestro.
// ═══════════════════════════════════════════════════════════════════════════════

/**
 * @param {Array}    options      [{ value, icon, label, hint?, isCustom?, placeholder?, maxLength? }]
 * @param {string}   selected     valor seleccionado actualmente
 * @param {Function} onSelect     (value) => void
 * @param {string}   customValue  texto escrito en la opción libre
 * @param {Function} onCustomChange (texto) => void
 * @param {boolean}  grid         true → rejilla de 2 columnas en desktop
 */
export default function OptionCards({
  options,
  selected,
  onSelect,
  customValue = '',
  onCustomChange,
  grid = false,
}) {
  return (
    <div className={`ob-options${grid ? ' ob-options-grid' : ''}`} role="radiogroup">
      {options.map((opt) => {
        const isSelected = selected === opt.value;
        const showInput = Boolean(opt.isCustom && isSelected);

        return (
          <div key={opt.value} className={showInput ? 'ob-card-wrap' : undefined}>
            <button
              type="button"
              role="radio"
              aria-checked={isSelected}
              className={`ob-card${isSelected ? ' ob-selected' : ''}`}
              onClick={() => onSelect(opt.value)}
            >
              <span className="ob-card-icon" aria-hidden="true">{opt.icon}</span>
              <span className="ob-card-body">
                <span>{opt.label}</span>
                {opt.hint && <span className="ob-card-hint">({opt.hint})</span>}
              </span>
            </button>

            {showInput && (
              <input
                type="text"
                className="ob-input ob-card-input"
                placeholder={opt.placeholder}
                maxLength={opt.maxLength ?? 100}
                value={customValue}
                onChange={(e) => onCustomChange?.(e.target.value)}
                // El usuario acaba de tocar la tarjeta: el foco va al input para
                // que no tenga que dar un segundo tap en móvil.
                autoFocus
              />
            )}
          </div>
        );
      })}
    </div>
  );
}

/**
 * Micro-reacción del sistema. El documento define un texto distinto por
 * elección en casi todas las pantallas — este bloque es donde se muestra.
 */
export function MicroReaction({ text }) {
  if (!text) return null;
  return (
    <div className="ob-reaction">
      <span className="ob-card-icon" aria-hidden="true">💬</span>
      <p className="ob-reaction-text">{text}</p>
    </div>
  );
}
